<template>

	<div class="d-flex flex-row">
		<v-text-field 
			ref="inputField"
			v-model="field.value"
			:label="field.template.name"
			:rules="agile.fieldRules.integerRule"
			outlined
			dense
			validate-on-blur
			style="max-width: 180px;"
			class="ai-align-right"
		>
		</v-text-field>
		<v-btn icon @click="decrement" class="ml-1">
			<v-icon>mdi-minus-circle</v-icon>
		</v-btn>
		<v-btn icon @click="increment" class="ml-n1">
			<v-icon>mdi-plus-circle</v-icon>
		</v-btn>
	</div>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";

export default
{
	name: 'ContentFieldInteger',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		value: '',
	}),

	computed:
	{
        agile()
        {
            return agile;
		},
	},


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		this.field.value = this.field.template.typeProperties.defaultValue;

		if (this.field.data)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
			}
			
		}

	},

	mounted()
	{
		this.$refs.inputField.$el.addEventListener("input", this.validateKey);
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		validateKey()
		{
			const inputElement = this.$refs.inputField.$el.getElementsByTagName("input")[0];
			let v = inputElement.value;

			if (v.includes('-')) v = '-'+v.replace(/-/g, '');
			v = v.toString().replace(/[^0-9-]+/g, '');
			inputElement.value = v;
			this.field.value = v;
		},

		increment()
		{
			this.field.value = parseInt(this.field.value)+1;
		},

		decrement()
		{
			this.field.value = parseInt(this.field.value)-1;
		}
	},

	beforeDestroy()
	{
		this.$refs.inputField.$el.removeEventListener("input", this.validateKey);
	},

}

</script>

